import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class ProjectManager extends ManagerBase {
	constructor () {
		super("projectManager");
		this.remoteClassName = "project";
	}

	reOpen (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "re-open";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						item.import(data.items[0]);
						item.clean();

						return {
							data: item,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	// projectManager.addMethod("create", function (project) {
	// 	Shark.requestRemoteData({
	// 		context: projectManager,
	// 		data: {an: "insert", d: project.export(), cx: "Project", userGuid: Shark.get("currUser").id},
	// 		complete: function (response) {
	// 			if (response.isSuccess) {
	// 				var responseData = response.data;

	// 				switch (responseData.rc) {
	// 					case 1:
	// 						Shark.appData.projectList = Shark.appData.projectList || [];

	// 						Shark.get("newProject").import(responseData.rows[0]);
	// 						this.emit("created");

	// 						Shark.get("projectList").push(Shark.get("newProject"));
	// 						this.emit("listChanged");
	// 						break;
	// 					case 7:
	// 						this.emit("error", "error_missingData");
	// 						break;
	// 					case 9:
	// 						this.emit("error", "error_default");
	// 						break;
	// 				}
	// 			}
	// 		}
	// 	});
	// });

	// projectManager.addMethod("getList", function (projectId, getActiveProjects = false, getAllClosedProjects = false, getAllOpenProjects = false, getCreatedProjects = false) {
	// 	//Object.assign({getAllOpenProjects: Shark.get("activeItems").showAllOpenProjects}, )
		
	// 	if (Shark.get("activeItems").showActiveProjects !== undefined) {
	// 		getActiveProjects = Shark.get("activeItems").showActiveProjects;
	// 	}

	// 	if (Shark.get("activeItems").showAllClosedProjects !== undefined) {
	// 		getAllClosedProjects = Shark.get("activeItems").showAllClosedProjects;
	// 	}

	// 	if (Shark.get("activeItems").showAllOpenProjects !== undefined) {
	// 		getAllOpenProjects = Shark.get("activeItems").showAllOpenProjects;
	// 	}

	// 	if (Shark.get("activeItems").showCreatedProjects !== undefined) {
	// 		getCreatedProjects = Shark.get("activeItems").showCreatedProjects;
	// 	}

	// 	if (!getActiveProjects && !getAllClosedProjects && !getAllOpenProjects && !getCreatedProjects) {
	// 		Shark.set("activityList", []);
	// 		this.emit("listChanged");
	// 		return;
	// 	}
		
	// 	Shark.requestRemoteData({
	// 		context: projectManager,
	// 		data: {an: "getList", getActiveProjects: getActiveProjects, getAllClosedProjects: getAllClosedProjects, getAllOpenProjects: getAllOpenProjects, getCreatedProjects: getCreatedProjects, cx: "Project", userGuid: Shark.get("currUser").id},
	// 		complete: function (response) {
	// 			if (response.isSuccess) {
	// 				var responseData = response.data;

	// 				switch (responseData.rc) {
	// 					case 1:
	// 						const projectList = Shark.getInstanceList("Project", responseData.rows);
							
	// 						projectList.sort(function (a, b) {
	// 							if (a.name > b.name) {
	// 								return 1;
	// 							}
	// 							else if (a.name < b.name) {
	// 								return -1;
	// 							}
	// 							return 0;
	// 						});
	// 						Shark.set("projectList", projectList);
							
	// 						this.emit("listChanged");

	// 						break;
	// 					case 7:
	// 						this.emit("error", "error_missingData");
	// 						break;
	// 					case 9:
	// 						this.emit("error", "error_default");
	// 						break;
	// 				}
	// 			}
	// 		}
	// 	});
	// });
}

const projectManager = new ProjectManager();

Shark.registerController(projectManager);

export default projectManager;
